/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface VerifyEmail200ResponseDataTokens
 */
export interface VerifyEmail200ResponseDataTokens {
  /**
   *
   * @type {string}
   * @memberof VerifyEmail200ResponseDataTokens
   */
  tokenType: string
  /**
   * Срок жизни access-токена в секундах
   * @type {number}
   * @memberof VerifyEmail200ResponseDataTokens
   */
  expiresIn: number
  /**
   *
   * @type {string}
   * @memberof VerifyEmail200ResponseDataTokens
   */
  accessToken: string
  /**
   *
   * @type {string}
   * @memberof VerifyEmail200ResponseDataTokens
   */
  refreshToken: string
}

/**
 * Check if a given object implements the VerifyEmail200ResponseDataTokens interface.
 */
export function instanceOfVerifyEmail200ResponseDataTokens(
  value: object
): value is VerifyEmail200ResponseDataTokens {
  if (!('tokenType' in value) || value['tokenType'] === undefined) return false
  if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false
  if (!('accessToken' in value) || value['accessToken'] === undefined)
    return false
  if (!('refreshToken' in value) || value['refreshToken'] === undefined)
    return false
  return true
}

export function VerifyEmail200ResponseDataTokensFromJSON(
  json: any
): VerifyEmail200ResponseDataTokens {
  return VerifyEmail200ResponseDataTokensFromJSONTyped(json, false)
}

export function VerifyEmail200ResponseDataTokensFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): VerifyEmail200ResponseDataTokens {
  if (json == null) {
    return json
  }
  return {
    tokenType: json['tokenType'],
    expiresIn: json['expiresIn'],
    accessToken: json['accessToken'],
    refreshToken: json['refreshToken'],
  }
}

export function VerifyEmail200ResponseDataTokensToJSON(
  value?: VerifyEmail200ResponseDataTokens | null
): any {
  if (value == null) {
    return value
  }
  return {
    tokenType: value['tokenType'],
    expiresIn: value['expiresIn'],
    accessToken: value['accessToken'],
    refreshToken: value['refreshToken'],
  }
}
